/** Matches `@assistente: prompt` at end of text (multiline prompt allowed). */
const ASSISTANT_DIRECTIVE_RE = /@assistente\s*:\s*([\s\S]+)$/i;

export type AssistantDirective = {
  bodyWithoutDirective: string;
  prompt: string;
};

export function parseAssistantDirective(text: string): AssistantDirective | null {
  const match = text.match(ASSISTANT_DIRECTIVE_RE);
  if (!match?.[1]) return null;
  const prompt = match[1].trim();
  if (!prompt) return null;
  const bodyWithoutDirective = text.slice(0, match.index).trimEnd();
  return { bodyWithoutDirective, prompt };
}

export function extractAIJobOutputText(
  providerUsageJson: string | null | undefined,
): string | null {
  if (!providerUsageJson?.trim()) return null;
  try {
    const root = JSON.parse(providerUsageJson) as Record<string, unknown>;
    const raw = String(root.outputText ?? "").trim();
    return raw || null;
  } catch {
    return null;
  }
}
